import PropTypes from 'prop-types'

import { ReactComponent as AddIcon } from './addGuest.svg'
import styles from './AddGuestButton.module.scss'

const AddGuestButton = ({ onClick, mini }) => (
  <button className={mini ? styles.miniButton : styles.button} onClick={onClick}>
    <AddIcon />
    Add guest
  </button>
)

AddGuestButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  mini: PropTypes.bool
}

export default AddGuestButton
